(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-molinard-workshops"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lpmol-workshops]').forEach(function (root) {
      if (root.dataset.lpmolInit === '1') return;
      var track = root.querySelector('[data-carousel-track]');
      if (!track) return;
      root.dataset.lpmolInit = '1';
      var cards = Array.prototype.slice.call(track.children);
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
      if (!cards.length) return;
      function currentIndex() {
        var x = track.scrollLeft;
        var best = 0, bestDist = Infinity;
        cards.forEach(function (card, i) {
          var d = Math.abs(card.offsetLeft - track.offsetLeft - x);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }
      function goTo(i) {
        i = Math.max(0, Math.min(cards.length - 1, i));
        track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      function sync() {
        var i = currentIndex();
        dots.forEach(function (dot, j) { dot.classList.toggle('is-active', j === i); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === cards.length - 1;
      }
      if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
      dots.forEach(function (dot, j) { dot.addEventListener('click', function () { goTo(j); }); });
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; sync(); });
      }, { passive: true });
      sync();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) { e.target.querySelectorAll ? initAll(e.target) : initAll(document); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
